import React from "react";
import { useDispatch, useSelector } from "react-redux";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { IconButton, Tooltip } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import secureLocalStorage from "react-secure-storage";
import Typography from "@mui/material/Typography";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { approveAdvice, deleteAdvice } from "../actions/unapprovedAdvice";
import { Helmet } from "react-helmet-async";
import { message, Popconfirm } from "antd";
import moment from "moment";

const columns = [
  { id: "code", label: "Code", minWidth: 100 },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
    align: "right",
  },
  {
    id: "date",
    label: "Date",
    minWidth: 170,
    align: "right",
  },
  {
    id: "description",
    label: "Description",
    minWidth: 170,
    align: "right",
  },
  {
    id: "amount",
    label: "Amount",
    minWidth: 170,
    align: "right",
  },
  {
    id: "sanction_by",
    label: "Sanction By",
    minWidth: 170,
    align: "right",
  },
];
function createData(id, code, status, date, description, amount, sanction_by) {
  return {
    id,
    code,
    status,
    date,
    description,
    amount,
    sanction_by,
  };
}
export default function Approval() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const unapproved = useSelector((state) => state.unapprovedAdvice);

  const rows = unapproved.map((data) =>
    createData(
      data._id,
      data.code,
      data.status,
      moment(data.date).format("DD-MM-YYYY"),
      data.description,
      data.amount,
      data.submitted_by
    )
  );
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const dispatch = useDispatch();

  const confirm = (id) => {
    dispatch(
      approveAdvice(id, {
        approved: "true",
        approved_by: user.results.firstName + " " + user.results.lastName,
        approvers_position: user.results.position,
      })
    );
  };
  const confirmDelete = (id) => {
    dispatch(deleteAdvice(id));
  };
  const cancel = () => {
    message.info("Nothing was submitted");
  };
  return (
    <div>
      <Helmet title='Approvals | Advice' />
      <Typography variant='h6'>
        {rows.length} Pending Advice for approval
      </Typography>

      <TableContainer sx={{ maxHeight: 540, marginTop: "30px", width: "100%" }}>
        <Table
          size='small'
          stickyHeader
          aria-label='sticky table'
          style={{ backgroundColor: "#FFF" }}
          sx={{
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,

              // bgcolor: "#cccc",
            },
          }}>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    top: 0,
                    minWidth: column.minWidth,
                    backgroundColor: "#E3A417",
                    color: "#000",
                  }}>
                  {column.label}
                </TableCell>
              ))}
              <TableCell style={{ backgroundColor: "#E3A417", color: "#000" }}>
                ACTIONS
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role='checkbox' tabIndex={-1} key={row.id}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                    <TableCell
                      style={{
                        backgroundColor: "#ccc",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      align='center'>
                      <Popconfirm
                        title='Advice approval'
                        description='Proceed approving advice?'
                        okText='Yes'
                        onConfirm={() => confirm(row.id)}
                        onCancel={cancel}
                        cancelText='No'>
                        <Tooltip title='approve advice'>
                          <IconButton
                            style={{ border: "1px solid #000" }}
                            size='small'>
                            <CheckOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Popconfirm>

                      <Popconfirm
                        title='Decline Advice'
                        description='Proceed declining advice?'
                        okText='Yes'
                        onConfirm={() => confirmDelete(row.id)}
                        onCancel={cancel}
                        cancelText='No'>
                        <Tooltip title='delete'>
                          <IconButton
                            style={{ border: "1px solid #000" }}
                            size='small'>
                            <DeleteOutlineOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Popconfirm>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component='div'
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}
